<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: 1000px">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>

        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group
              horizontal
              name="code"
              :label="$t('attributes.airline_code')"
            >
              <b-input
                v-model="form.code"
                name="code"
                maxlength="2"
                :has-counter="false"
                :disabled="isUpdate"
                :placeholder="
                  $t('message.please_input') + $t('attributes.airline_code')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="english_name"
              :label="$t('attributes.english_name')"
            >
              <b-input
                v-model="form.english_name"
                name="english_name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.english_name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="contact_person"
              :label="$t('attributes.contact_person')"
            >
              <b-input
                v-model="form.contact_person"
                name="contact_person"
                :placeholder="
                  $t('message.please_input') + $t('attributes.contact_person')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="res_tel"
              :label="$t('attributes.reservation_phone')"
            >
              <b-input
                v-model="form.res_tel"
                name="res_tel"
                :placeholder="
                  $t('message.please_input') +
                    $t('attributes.reservation_phone')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="address"
              :label="$t('attributes.address')"
            >
              <b-input
                v-model="form.address"
                name="contact_person"
                :placeholder="
                  $t('message.please_input') + $t('attributes.address')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="picture"
              attribute="attributes.picture"
              :label="$t('attributes.picture')"
              grouped
            >
              <template #label>
                {{ $t('attributes.picture') }}
                <b-tooltip type="is-dark" label="35*40/限png,jpg檔，100KB內">
                  <b-icon
                    size="is-small"
                    type="is-danger"
                    icon="help-circle-outline"
                  ></b-icon>
                </b-tooltip>
              </template>
              <b-field class="file">
                <a class="button is-primary" @click="onSelectPictureImage">
                  <b-icon icon="upload"></b-icon>
                  <span>{{ $t('message.please_select_file') }}</span>
                </a>
                <figure v-if="form.picture" class="image">
                  <img
                    :src="AirlineImage(form.picture)"
                    :alt="$t('attributes.picture')"
                    style="width: 40px; margin-left: 6px;"
                  />
                </figure>
              </b-field>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button
            :loading="isLoading"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="isLoading"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{
              this.airline.code ? $t('attributes.update') : $t('attributes.add')
            }}
          </b-button>
        </footer>

        <b-loading :active.sync="isLoading" :can-cancel="false"></b-loading>
      </div>
    </form>
  </section>
</template>

<script>
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import { OpenAirlineFinder } from '@/utils/ckfinder'
import notifyService from '@/services/notifyService'

export default {
  name: 'AirlineForm',

  props: {
    airline: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      sending: false,
      isUpdate: !!this.airline.code,
      form: this.extractFormValues(this.airline),

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      code: { required, minLength: minLength(2), maxLength: maxLength(2) },
      name: { required, maxLength: maxLength(50) },
      english_name: { maxLength: maxLength(100) },
      res_tel: { maxLength: maxLength(20) },
      contact_person: { maxLength: maxLength(30) },
      address: { maxLength: maxLength(100) },
      picture: { required, maxLength: maxLength(100) }
    }
  },
  computed: {
    formTitle() {
      let title = this.airline.code
        ? this.$t('attributes.modify')
        : this.$t('attributes.add')

      title += this.$t('attributes.airline')

      return title
    },
    isLoading() {
      return this.sending
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        code: data.code,
        name: data.name && data.name.trim(),
        english_name: data.english_name && data.english_name.trim(),
        res_tel: data.res_tel && data.res_tel.trim(),
        contact_person: data.contact_person && data.contact_person.trim(),
        address: data.address && data.address.trim(),
        picture: data.picture && data.picture.trim()
      }
    },
    async onSelectPictureImage() {
      try {
        this.form.picture = await OpenAirlineFinder()
      } catch (e) {
        notifyService.error(e)
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
